import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsElloComponent } from './simple-icons-ello.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsElloComponent ],
    exports:      [ SimpleIconsElloComponent ],
    bootstrap:    []
})
export class SimpleIconsElloModule {}
